import { down, up } from "styled-breakpoints";
import styled from "styled-components";
import { Title as T } from "sunday-component";
import { Card as C, Col, Skeleton } from "antd";
import { color } from "src/styles/globals";

export const Card = styled(C)`
  display: flex;
  align-items: flex-start;
  border-radius: 12px;
  border: 1px solid ${color.charcoal05};
  height: 148px;
  ${down("sm")} {
    height: 100%;
  }
`;
export const InsurerImage = styled.img`
  width: auto;
  height: 20px;
  align-self: start;
  margin-bottom: 4px;
`;
export const CategoryImage = styled.img`
  width: 64px;
  height: 64px;
`;
export const CardDetailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${down("sm")} {
    height: 100%;
  }
`;
export const LogoTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 8px;
`;

export const DesktopTitle = styled(T).attrs({ level: 7 })`
  ${down("sm")} {
    display: none;
  }
  line-height: 23.1px;
  text-align: left;
`;
export const MobileTitle = styled(T).attrs({ level: 7 })`
  ${up("md")} {
    display: none;
  }
  line-height: 23.1px;
  text-align: left;
`;

export const CardContainer = styled(Col)`
  height: 100%;
`;
export const SkeletonTitle = styled(Skeleton)`
  margin: auto;
  .ant-skeleton-title {
    height: 14px;
  }
`;
